import { render, staticRenderFns } from "./showList.vue?vue&type=template&id=040b1ec0&scoped=true"
import script from "./showList.vue?vue&type=script&lang=js"
export * from "./showList.vue?vue&type=script&lang=js"
import style0 from "./showList.vue?vue&type=style&index=0&id=040b1ec0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b1ec0",
  null
  
)

export default component.exports